import BrandLogo from "@/components/yts/BrandLogo";
import LangSwitch from "@/components/yts/LangSwitch";
import { useLang } from "@/lib/i18n";
import { startTour } from "@/lib/tour";

// Kept to the site's own pages: About and Contact live here so every screen
// links to them.
const LINKS = [
{ to: "/", key: "nav.explore" },
{ to: "/es/", key: null },
{ to: "/events", key: "nav.events" },
{ to: "/business", key: "nav.business" },
{ to: "/advertise/store", key: null },
{ to: "/advertise", key: "nav.advertise" },
{ to: "/advertise/dashboard", key: "adDash.navLink" },
{ to: "/visitor-services", key: null },
{ to: "/faq", key: null },
{ to: "/about", key: "nav.about" },
{ to: "/contact", key: "nav.contact" },
{ to: "/privacy", key: "nav.privacy" },
{ to: "/terms", key: "nav.terms" }];


export default function SiteFooter() {
  const { t, lang } = useLang();

  return (
    <footer className="mt-8 border-t border-black/[0.09] bg-[#f7f6f2] dark:bg-[#131211] sm:mt-16">
      <div className="max-w-[1180px] mx-auto px-4 sm:px-6 pt-10 sm:pt-12 pb-[calc(96px_+_env(safe-area-inset-bottom,0px))] sm:pb-10">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-[440px]">
            <BrandLogo variant="footer" />
            <p className="mt-3 max-w-[320px] text-[13px] leading-6 text-[#6d6d6a]">{lang === "es" ? "Puerto Rico, más allá de las paradas de siempre. Explora lugares locales, cultura, comida y experiencias que valen la pena." : "Puerto Rico, beyond the usual stops. Find local places, culture, food, and experiences worth knowing."}</p>
            
          </div>
          





          
        </div>
        <nav aria-label="Footer navigation" className="mt-8 grid grid-cols-2 gap-x-8 gap-y-3 border-t border-black/[0.09] pt-6 text-[12px] font-semibold text-[#44443f] sm:grid-cols-3 lg:grid-cols-5">
          {LINKS.map((link) => (
            <a key={link.to} href={link.to} className="transition-colors hover:text-[#e33a32] hover:underline underline-offset-4">
              {link.to === "/es/" ? (lang === "es" ? "Guía local en español" : "Spanish local guide") : link.to === "/visitor-services" ? (lang === "es" ? "Servicios al visitante" : "Visitor services") : link.to === "/faq" ? (lang === "es" ? "Guía y preguntas frecuentes" : "Visitor FAQ") : link.to === "/advertise/store" ? (lang === "es" ? "Comprar banners" : "Shop banner ads") : t(link.key)}
            </a>
          ))}
          <a href="/jobs" className="transition-colors hover:text-[#e33a32] hover:underline underline-offset-4">{lang === "es" ? "Empleos · Powered by ClasificadosOnline.com" : "Jobs · Powered by ClasificadosOnline.com"}</a>
        </nav>
        <div className="mt-6 flex flex-col gap-1.5 sm:flex-row sm:items-center sm:justify-between sm:gap-4 text-[11px] text-[#6d6d6a]">
          <div>
            © {new Date().getFullYear()} Ya Tú Sabes PR · {t("footer.made")}
          </div>
          {/* Where the language is changed after arrival: the welcome card asks
                   once, and the footer keeps the choice reversible ever after. */}
          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={startTour}
              className="font-bold text-[#44443f] underline underline-offset-4 transition-colors hover:text-[#e33a32]"
            >
              {lang === "es" ? "Tour del sitio" : "Tour the site"}
            </button>
            <LangSwitch />
          </div>
          {/* The address, written out site-wide — the same inbox the contact
                   form writes to, for anyone who would rather mail us directly. */}
          

          
        </div>
      </div>
    </footer>);

}